import { useState } from "react";
import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useTableControls from "../../Hooks/useTableControls";
import useFetchData from "../../Hooks/useFetchData";
import { getAllUsers, USER_STATUS_FILTER_OPTIONS } from "../../Services/User";
import AccountDeletionBadge, { isAccountDeleted } from "../../Components/AccountDeletionBadge";
import { runAccountStatusChange } from "../../Utils/accountStatusFlow";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";
import "../Dashboard/Dashboard.css";

export default function UserManagement() {
  // const sampleData = [
  //   {
  //     sn: "1",
  //     src: "images/avatar2.png",
  //     name: "Mark Carson",
  //     email: "abc@xyz.com",
  //     registeredOn: "01/02/2022",
  //     status: true,
  //   },
  //   {
  //     sn: "2",
  //     src: "images/avatar2.png",
  //     name: "Mark Carson",
  //     email: "abc@xyz.com",
  //     registeredOn: "01/02/2022",
  //     status: false,
  //   },
  //   {
  //     sn: "3",
  //     src: "images/avatar2.png",
  //     name: "Mark Carson",
  //     email: "abc@xyz.com",
  //     registeredOn: "01/02/2022",
  //     status: true,
  //   },
  //   {
  //     sn: "4",
  //     src: "images/avatar2.png",
  //     name: "Mark Carson",
  //     email: "abc@xyz.com",
  //     registeredOn: "01/02/2022",
  //     status: true,
  //   },
  // ];

  const {
    perPage,
    setPerPage,
    status,
    setStatus,
    search_string,
    setSearchString,
    from,
    setFrom,
    to,
    setTo,
  } = useTableControls();

  const {
    // INTERNAL EXPORTS
    page,
    setPage,
    // REACT QUERY EXPORTS
    isFetching,
    isLoading,
    data,
    refetch,
  } = useFetchData("user_logs", getAllUsers, [
    perPage,
    "user",
    search_string,
    status,
    from,
    to,
  ]);
  // console.log("user_logs Data: ", data?.data);

  const [loadingStatus, setLoadingStatus] = useState(false);

  return (
    <div className="app-content content">
      <div className="content-wrapper">
        <div className="content-body">
          {/* Basic form layout section start */}
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <PageHeader
                    title="Users Management"
                    subtitle="View and manage registered users and their account status"
                  />
                  <Table
                    key={"user-management-table"}
                    tableTitles={[
                      "S.No.",
                      "Full Name",
                      "Email Address",
                      "Date Registered",
                      "Status",
                      "Action",
                    ]}
                    dateFilter
                    showEntries
                    sortBy
                    isLoading={isLoading}
                    isFetching={isFetching}
                    data={data?.data?.data?.docs}
                    totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                    totalDocs={data?.data?.data?.totalDocs}
                    page={page}

                    setPage={setPage}
                    setSearchString={setSearchString}
                    status={status}
                    setStatus={setStatus}
                    status_options={USER_STATUS_FILTER_OPTIONS}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    from={from}
                    setFrom={setFrom}
                    to={to}
                    setTo={setTo}
                  >
                    {data?.data?.data?.docs?.map((item, index) => {
                      // Apple may never share an email; those customers finish setup without one.
                      const isIncomplete = !item.firstName || (!item.email && item.socialProvider !== "apple");
                      return (
                        <tr key={index}>
                          <td>{getSerialNumber(data?.data?.data, index)}</td>
                          <td>{item.firstName || <span className="text-muted" style={{ fontSize: '0.85rem' }}>Profile Incomplete</span>}</td>
                          <td>
                            {item.email || (
                              <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                                {isAccountDeleted(item) ? "Removed" : item.socialProvider === "apple" ? "Not shared (Apple)" : "Profile Incomplete"}
                              </span>
                            )}
                          </td>
                          <td>
                            {item?.createdAt &&
                              format_date(item?.createdAt, "MM/DD/YYYY")}
                          </td>
                          <td>
                            {isAccountDeleted(item) ? (
                              <AccountDeletionBadge item={item} className="" />
                            ) : (
                              <>
                                <span className={`status-pill ${isIncomplete ? 'status-pending' : (item.active ? 'status-active' : 'status-inactive')}`}
                                >
                                  {isIncomplete ? "Incomplete" : (item.active ? "Active" : "Inactive")}
                                </span>
                                {item?.active && item?.pendingSuspension ? (
                                  <span className="status-pill status-pending ms-1" title="Will be suspended when the current delivery ends">
                                    Suspension scheduled
                                  </span>
                                ) : null}
                                <AccountDeletionBadge item={item} />
                              </>
                            )}
                          </td>
                          <td>
                            <StatusHandler
                              key={`${item?._id}-status`}
                              view
                              suspend={!isAccountDeleted(item)}
                              item={item}
                              isLoading={loadingStatus}
                              redirectUrl={`/user-management/user-details/${item?._id}`}
                              onClick={() =>
                                runAccountStatusChange({
                                  item,
                                  label: "User",
                                  onDone: refetch,
                                  setBusy: setLoadingStatus,
                                })
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </Table>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="inactiveUser"
              data-bs-backdrop="static"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
            >
              <div
                className="modal-dialog modal-dialog-centered site-modal"
                role="document"
              >
                <div className="modal-content">
                  <div className="modalIndex">
                    <i
                      className="fas fa-times close modal-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                    <div className="text-center">
                      <div className="modal-text-content mb-1">
                        <div className="modalImg">
                          <img
                            src="images/question.png"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <div className="modal-text-content my-4">
                          <p className="modalText">
                            Are you sure you want to In-Active Mark Carson?
                          </p>
                        </div>
                      </div>
                      <div className="modalAction">
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="siteBtn2 mx-1"
                        >
                          No
                        </button>
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="siteBtn mx-1"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="activeUser"
              data-bs-backdrop="static"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
            >
              <div
                className="modal-dialog modal-dialog-centered site-modal"
                role="document"
              >
                <div className="modal-content">
                  <div className="modalIndex">
                    <i
                      className="fas fa-times close modal-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                    <div className="text-center">
                      <div className="modal-text-content mb-1">
                        <div className="modalImg">
                          <img
                            src="images/question.png"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <div className="modal-text-content my-4">
                          <p className="modalText">
                            Are you sure you want to Active Mark Carson?
                          </p>
                        </div>
                      </div>
                      <div className="modalAction">
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="siteBtn2 mx-1"
                        >
                          No
                        </button>
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="siteBtn mx-1"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
            <style>{`
                .fw-800 { font-weight: 800; }
                
                @media (max-width: 576px) {
                    .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                    .user-details-wrapper { padding: 0.5rem; }
                }
            `}</style>
    </div>
  );
}
